import {
  createContext,
  useContext,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";

const NavigationGuardContext =
  createContext(null);

export const NavigationGuardProvider = ({
  children,
}) => {
  const navigate = useNavigate();

  const [shouldBlock, setShouldBlock] =
    useState(false);

  const [blocked, setBlocked] =
    useState(false);

  const pendingPathRef = useRef(null);

  const requestNavigation = (
    path,
    options = {},
  ) => {
    if (!shouldBlock) {
      navigate(path, options);
      return;
    }

    pendingPathRef.current = {
      path,
      options,
    };

    setBlocked(true);
  };

  const leavePage = () => {
    const pendingNavigation =
      pendingPathRef.current;

    setBlocked(false);
    setShouldBlock(false);
    pendingPathRef.current = null;

    if (pendingNavigation) {
      navigate(
        pendingNavigation.path,
        pendingNavigation.options,
      );
    }
  };

  const stayOnPage = () => {
    setBlocked(false);
    pendingPathRef.current = null;
  };

  return (
    <NavigationGuardContext.Provider
      value={{
        blocked,
        shouldBlock,
        setShouldBlock,
        requestNavigation,
        leavePage,
        stayOnPage,
      }}
    >
      {children}
    </NavigationGuardContext.Provider>
  );
};

export const useNavigationGuard = () => {
  const context = useContext(
    NavigationGuardContext,
  );

  if (!context) {
    throw new Error(
      "useNavigationGuard must be used inside NavigationGuardProvider",
    );
  }

  return context;
};